
import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useTranslation } from 'react-i18next';

const HelpModal = (props) => {
  const {
    isOpen,
    toggle,
    className,
    text,
    title
  } = props;
  const { t } = useTranslation('common')

  return (
    <Modal isOpen={isOpen} toggle={toggle} className={className}>
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>
        {text}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" className="mx-auto" onClick={toggle}>{t('actions.close')}</Button>
      </ModalFooter>
    </Modal>
  );
}

export default HelpModal;